import { Link } from 'gatsby';
import * as React from 'react';
import Logo50 from '../../../assets/Logo50.svg'
import LogoACS from '../../../assets/LogoACS.svg'
import LogoCS from '../../../assets/LogoCS.svg'
import LogoUPB from '../../../assets/LogoUPB.png'
import Button from '../../../atoms/Button';
import './index.scss'
import LanguageSelector from '../../../atoms/LanguageSelector';

export interface HeaderProps {
}

export default class Header extends React.Component<HeaderProps, any> {
  public render() {
    return (
      <header>
        <Link to="/">
          <Button>⬅</Button>
        </Link>
        <img src={LogoUPB} />
        <img src={LogoACS} />
        <LanguageSelector />
        <img src={Logo50} />
        <div className="separator" />
        <img src={LogoCS} />
      </header>
    );
  }
}
